import {Injectable} from '@angular/core';
import {OccEndpointsService, TranslationService} from '@spartacus/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable} from 'rxjs';

import {failStatus, successStatus} from '../../../../core/models/request-status.model';
import {DashboardRequestConfig, DashboardStatusRequest} from "./dashboard.model";

@Injectable({
  providedIn: 'root',
})
export class DashboardAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService
  ) {}

  getRecentBuyItems(dashboardRequestConfig: DashboardRequestConfig): Observable<DashboardStatusRequest> {
    const url = this.occEndPointService.buildUrl('getRecentBuyItems', {
      urlParams: {
        itemCount: dashboardRequestConfig.itemCount,
      },
    });

    return this.http.get(url).pipe(
      map((response: any) => ({
        recentBuyItems: response,
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }
}
